import * as signalR from "@microsoft/signalr";

export class WebsocketController {

    readonly connection: signalR.HubConnection;
    
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/totalhub")
            .withAutomaticReconnect()
            .build();

            // TODO: Maybe use a Web Lock
            // TODO: A function to reconnect if the tab get's active again
            // TODO: Check if app maybe should just refresh completely after tab is active again
    }

    public async startIfNeeded() {
        while(this.connection.state === signalR.HubConnectionState.Connecting) {
            await new Promise(r => setTimeout(r, 50));
        }
        
        if(this.connection.state !== signalR.HubConnectionState.Connected) {
            await this.connection.start();
        }
    }

    public async addHandler(methodName: string, handler: (...args: any[]) => void) {
        await this.startIfNeeded();
        this.connection.on(methodName, handler);
    }

    public removeHandler(methodName: string, handler: (...args: any[]) => void) {
        this.connection.off(methodName, handler);
    }

    public async invokeFunction(methodName: string, ...args: any[]) {
        await this.startIfNeeded();
        this.connection.invoke(methodName, ...args);
    }
}


export const WebsocketControllerSingleton = new WebsocketController(); 